import { atom } from "recoil";

export const crmFilteredTransaction = atom({
  key: "crm-filter",
  default: null,
});
